import { tv, type VariantProps } from '@workspace/lib';

export const modalVariants = tv({
  slots: {
    modal:
      'inset-0 md:inset-auto md:top-1/2 md:left-1/2 md:-translate-x-1/2 md:-translate-y-1/2 h-dvh w-full max-h-none md:h-auto md:max-h-[90vh] bg-secondary-50 text-inherit shadow-xl backdrop:bg-black/50',
    header: 'bg-secondary-50',
    headerContent: 'p-4 pb-0 md:px-8',
    closeButton: 'text-secondary-300 hover:text-secondary-400',
  },
  variants: {
    variant: {
      default: {},
      media: {
        modal:
          'inset-0 md:top-0 md:left-0 md:translate-x-0 md:translate-y-0 h-dvh w-full max-h-none md:max-h-none overflow-hidden bg-black/90 text-white shadow-none backdrop:bg-black/90',
        header: 'bg-transparent',
        headerContent: 'mx-auto w-full max-w-300 pt-9 md:px-0 md:pt-21',
        closeButton: 'text-white hover:text-white',
      },
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type ModalVariants = VariantProps<typeof modalVariants>;
